import { graphql } from "@/gql";

export const globalSupplierSelectionList = graphql(`
  query GlobalSupplierSelectionList($first: Int!, $page: Int) {
    suppliers(
      page: $page
      first: $first
      orderBy: [{ column: NAME, order: ASC }]
      managed_by_me: true
      archived: false
    ) {
      data {
        id
        name

        created_at
        updated_at

        ...SupplierIconFields
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
